import React from 'react';
import styles from './styles.scss';

export default ({ msg }) =>{
  return(
    <div className={styles.snackbar}>
      {msg}
    </div>
  )
}


// WEBPACK FOOTER //
// ./src/components/common/Snackbar/index.js